import { render, staticRenderFns } from "./SponsorItem.vue?vue&type=template&id=086051d4&lang=pug&"
import script from "./SponsorItem.vue?vue&type=script&lang=ts&"
export * from "./SponsorItem.vue?vue&type=script&lang=ts&"
import style0 from "./SponsorItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports